import { render } from "./Articles.vue?vue&type=template&id=1fdb75f7&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=1fdb75f7&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/tutuyoutoo-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdb75f7"]])

export default __exports__